module.exports = __webpack_public_path__ + "img/3화_12(2).f28b9b67.png";